import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import PageTitle from "../../../jsx/layouts/PageTitle";
import ExcelUsers from "./ExcelUsers";
import ManualForm from "./ManualForm";
import ShareForm from "./ShareForm";

const CreateNewUser = () => {
  const [addCard, setAddCard] = useState(false);
  const [showExcel, setShowExcel] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("mode") === "import" || params.get("tab") === "excel") {
      setShowExcel(true);
    }
  }, [location.search]);

  return (
    <>
      <PageTitle
        activeMenu={showExcel ? "Import Bulk Users" : "Manual User"}
        motherMenu="Users"
        Button={() => (
          <div className="d-flex flex-wrap gap-2">
            <Button
              className="btn btn-primary"
              variant={showExcel ? "outline-primary" : "primary"}
              onClick={() => {
                setShowExcel((prev) => !prev);
                setAddCard(false);
              }}
            >
              <i className={`fa ${showExcel ? "fa-user-plus" : "fa-file-excel"} me-2`}></i>
              {showExcel ? "Single User Form" : "Import Bulk Users (Excel / CSV)"}
            </Button>
            <Button
              className="btn btn-outline-secondary"
              variant="outline-secondary"
              onClick={() => {
                setAddCard(true);
              }}
            >
              <i className="fa fa-share-alt me-2"></i>
              Share Registration Form
            </Button>
          </div>
        )}
      />

      {addCard && <ShareForm addCard={addCard} setAddCard={setAddCard} />}

      {showExcel ? (
        <ExcelUsers onSwitchToManual={() => setShowExcel(false)} />
      ) : (
        <ManualForm />
      )}
    </>
  );
};

export default CreateNewUser;
